/** APIレスポンスのステータスコード */
export const API_STATUS_CODE = {
  /** リクエスト異常 */
  BAD_REQUEST: 400,
  /** 認証エラー */
  AUTH_ERROR: 401,
  /** デバイス初期化 */
  DEVICE_INITIAL: 411,
  /** ページが見つからない */
  PAGE_NOT_FOUND: 404,
  /** サービス無効（メンテナンス） */
  SERVICE_UNAVAILABLE: 503
};

/** KPサーバーが返却するエラーコード */
export const API_KP_SERVER_ERROR_CODE = {
  /** サーバー保守作業中 */
  SERVER_MAINTENANCE: "E400Z000",
  /** 強制バージョンアップ */
  FORCE_VERSION_UP: "E400Z999",
  /** メールアドレス・エラー */
  MAIL_ADDRESS_ERROR: "E500F007",
  /** ダウンロードメニューIDトークン期限切れ */
  DLMENUID_TOKEN_EXPIRED: "E700Z001",
  /** 付属品未登録 */
  ATTACHMENT_UNREGISTERED: "E300Z002"
};

/**  */
/** レシピ関連APIのURL */
export const API_URL_RECIPE = {
  /** レシピ検索API */
  SEARCH: "/recipe/search",
  /** おすすめのレシピリスト取得API */
  RECOMMEND: "/recipe/recommendation",
  /** 人気のレシピリスト取得API */
  RANKING: "/recipe/ranking",
  /** タグ一覧検索API */
  TAGS: "/recipe/tags",
  /** レシピ詳細 */
  DETAIL: "/recipe/detail-info",
  /** ユーザー閲覧履歴一覧取得API */
  USER_HISTORY: "/user/history/recipes",
  /** ユーザー送信履歴一覧取得API */
  USER_DOWNLOAD_HISTORY: "/user/download/history/recipes",
  /** お気に入り取得API */
  MYLIST: "/recipe/get-favorites",
  /** お気に入りレシピ登録 */
  MYLIST_RECIPE_ADD: "/recipe/favorite",
  /** お気に入りレシピ削除 */
  MYLIST_RECIPE_DELETE: "/recipe/favorite/delete",
  /** お気に入りフォルダ一覧取得API */
  MYLIST_FOLDER_LIST: "/recipe/favorite/folders",
  /** お気に入りフォルダ登録 */
  MYLIST_FOLDER_REGIST: "/recipe/favorite/folder",
  /** お気に入りフォルダ取得（フォルダ内レシピ取得） */
  MYLIST_FOLDER_RECIPE_LIST: "/recipe/favorite/folder/$folderId",
  /** お気に入りフォルダ更新 */
  MYLIST_FOLDER_RENAME: "/recipe/favorite/folder/$folderId",
  /** お気に入りフォルダ削除 */
  MYLIST_FOLDER_DELETE: "/recipe/favorite/folder/$folderId",
  /** お気に入りフォルダへのレシピ追加 */
  MYLIST_FOLDER_ADD_RECIPE: "/recipe/favorite/folder/$folderId/add-recipes",
  /** お気に入りフォルダからのレシピ削除 */
  MYLIST_FOLDER_REMOVE_RECIPE: "/recipe/favorite/folder/$folderId/remove-recipes",
  /** お気に入りフォルダ ソート順変更 */
  MYLIST_FOLDER_SORT: "/recipe/favorite/folder/$folderId/sort",
  /** 食品情報検索API */
  SEARCH_FOODS: "/recipe/foods",
  /** ユーザー食品利用ランキング取得API */
  RANKING_FOODS: "/recipe/users/ranking/foods",
  /** お気に入り食品(一覧取得)API */
  FAVORITE_FOODS: "/recipe/foods/favorite",
  /** お気に入りレシピ登録/削除 */
  FAVORITE_FOOD: "/recipe/food/favorite",
  /** お気に入りレシピ登録/削除 */
  FAVORITE_FOOD_QUERY: "/recipe/food/favorite?foodId=$foodId",
  /** 食品提案API */
  FOODS_RECOMMENDATION: "/recipe/foods/recommendations",
  /** ユーザー食品消費ランキング取得API */
  USED_FOOD_RANKING: "/recipe/users/ranking/used-foods",
  /** ユーザー食品消費度順位取得API */
  USER_RANKING: "/recipe/users/ranking/frequency-used-foods"
};

/** メニュー関連APIのURL */
export const API_URL_MENU = {
  /** シーン別カテゴリー一覧取得API */
  MENU_CATEGORIES: "/menu/categories",
  /** 一食献立提案API */
  ONE_MENU_RECOMMEDATION: "/onemenu/recommendations"
};

/** デバイス関連APIのURL */
export const API_URL_DEVICE = {
  /** 登録済み機器一覧 */
  REGISTERED: "/cp/device/registered"
};

/** 情報関連APIのURL */
export const API_URL_INFORMATON = {
  /** 特集バナー情報取得 */
  BANNER: "information/banners",
  /** 特集バナー情報取得 */
  SERVICE: "/information/services"
};

/** 買い物リスト関連APIのURL */
export const API_URL_SHOPPING_LIST = {
  /** 買い物リストの食材取得 */
  FOODS_LIST: "/shopping-list/foods",
  /** 買い物リストの食材登録 */
  FOODS_REGIST: "/shopping-list/foods",
  /** 買い物リスト食材の更新 */
  FOODS_CHECK_UPDATE: "/shopping-list/foods/$foodId",
  /** 買い物リストの食材削除 */
  FOODS_DELETE: "/shopping-list/foods/$foodId",
  /** チェック済み買い物リストクリア */
  FOODS_CHECK_CLEAR: "/shopping-list/check-item-clear",
  /** お気に入り食品(一覧取得)API */
  FOODS_FAVORITE: "/recipe/foods/favorite",
  /** お気に入り食品追加API */
  FOODS_APPEND_FAVORITE: "/recipe/food/favorite",
  /** 食品提案API */
  FOODS_RECOMMENDATION: "/recipe/foods/recommendations",
  /** 食品情報検索API */
  FOODS_SEARCH: "/recipe/foods",
  /** ユーザー食品利用ランキング取得 */
  FOODS_RANKING: "/recipe/users/ranking/foods",
  /** 消費済み */
  FOODS_CONSUMED: "/pantry/items/consume-foods",
  /** 買い物リストの食材検索 */
  SEARCH_INGREDIENT: "/recipe/foods",
  /** シーン別検索を行う際のカテゴリ一覧を取得するAPI */
  FOODS_CATEGORIES: "/menu/categories?scene=pantry",
};

/** 冷蔵庫APIのURL */
export const API_URL_FRIDGE = {
  /** エコナビ情報取得 */
  ECONAVI: "/devices/$applianceId/econavi",
  /** ドア開閉情報取得 */
  DOOROPNEINFO: "/devices/$applianceId/dooropeninfo",
  /** Push通知設定状態取得 */
  PUSHSETTING: "/devices/$applianceId/settings?term_id=$termId",
  /** Push通知設定状態登録 */
  PUSHSETTING_REGIST: "/devices/$applianceId/settings",
  /** 月別削減金額取得 */
  REDUCTIONINFO: "/devices/$applianceId/reduction",
  /** 運転状態取得 2 : 設定画面表示時 のみ*/
  GETSETTINGS: "/devices/$applianceId/status?usages=2",
  /** 運転状態取得 4 : 運転モード設定画面表示時 のみ*/
  GETSETTINGS_OP: "/devices/$applianceId/status?usages=4",
  /** 機器制御実行 */
  SETSETTINGS: "/devices/$applianceId/status",
  /** 冷蔵庫機能一覧 */
  FUNCTIONLIST: "/products/$applianceId/functions",
  /** マイリスト */
  MYLIST: "/devices/$applianceId/mylist",
  /** マイリスト削除 */
  MYLISTDELETE: "/devices/$applianceId/mylist?mylist_id=$mylistId",
  /** 本体設定 クーリングアシスト設定値取得 */
  GETCOOLINGASSISTSETTINGS: "/devices/$applianceId/status?usages=3",
  /** 冷蔵庫一覧 */
  DEVICELIST: "/devices"
}

/** クライアント定数 */
export const API_CLIENT_CONST = {
  /** User Agent のprefix */
  USER_AGENT_PREFIX: "KPWeb/"
};

/** パントリー関連APIのURL */
export const API_URL_PANTRY = {
  /** パントリー新一覧取得 */
  LIST: "/pantry/new-list",
  /** パントリー詳細情報取得,更新 */
  DETAIL: "/pantry/item/$pantryId",
  /** パントリー削除 */
  DELETE: "/pantry/items/new-delete",
  /** パントリー登録 */
  FOOD_REGISTER: "/pantry/item",
  /** パントリーScan登録（食材） */
  SCAN_INGREDIENTS_REGISTER: "/pantry/item/scan/ingredients",
  /** パントリー消費済み食材一覧取得 */
  CONSUME_FOODS: "/pantry/items/consume-foods",
  /** パントリー：重量検知プレート積載食材詳細情報取得 */
  PLATE_DETAIL: "/pantry/plate/item/detail",
  /** パントリー：重量検知プレート積載食材詳細情報取得 */
  UPDATE_PLATE_DETAIL: "/pantry/plate/item/$pantryPlateId",
  /** パントリー：重量検知プレート積載食材残量経過取得 */
  PLATE_SETTING_WEIGHT: "/pantry/plate/settings/weight",
  /** パントリー：重量検知プレート積載食材詳細登録 */
  PLATE_REGISTER: "/pantry/plate/item",
  /** パントリー：庫内情報取得 */
  FRIDGE_INFO: "/pantry/fridge/info",
  /** パントリー：冷蔵庫食材認識修正候補取得 */
  FRIDGE_RECOGNITION_CANDITATE: "/pantry/fridge/item/inference/info/$inferenceResultFoodId",
  /** パントリー：認識食材一覧取得 */
  FRIDGE_RECOGNITION_LIST: "/pantry/fridge/recognition-list",
  /** パントリー：冷蔵庫食材登録 */
  FRIDGE_REGISTER: "/pantry/fridge/items",
  /** パントリー：冷蔵庫食材 */
  FRIDGE_ITEM: "/pantry/fridge/item/$pantryFridgeId",
  /** パントリー：冷蔵庫食材詳細 */
  FRIDGE_DETAIL: "/pantry/fridge/item/detail/$pantryFridgeId",
  /** パントリー消費済み食材一覧取得 */
  FOODS_CONSUMED: "/pantry/items/consume-foods",
  /** 買い物リストの食材登録 */
  FOODS_REGIST: "/shopping-list/foods",
  /** 購入済み食材リスト取得 */
  PURCHASED_FOODS: "/shopping-list/purchased-foods",
  /** パントリー：冷蔵庫食材判定 */
  FRIDGE_ITEMS_JUDGE: "/pantry/fridge/items/judge",
  /** パントリー：冷蔵庫食材確認 */
  FRIDGE_ITEMS_CONFIRM:  "/pantry/fridge/items/confirm",
  /** 光軸設定API */
  OPTICAL_AXIS:  "/dv/devices/actions/optical-axis"
};

/** 重量検知プレートAPIのURL */
export const API_URL_PLATE = {
  /** 機器状態 */
  SETTINGS: "/plate/settings"
};

/** 問診関連APIのURL */
export const API_URL_INQUIRY = {
  /** 問診内容(カテゴリ)取得 */ 
  GET_CATEGORIES: "/mwo/inquiry/categories",
  /** 問診結果(カテゴリ)登録(更新) */
  REGIST_FAVORITECATEGORIES: "/mwo/inquiry/favorite-categories",
  /** 問診内容取得API */
  GET_QUESTIONS: "/inquiries/questions",
  /** 問診結果登録API */
  REGIST_ANSWERS: "/inquiries/answers",
  /** 問診回答状態取得API */
  GET_STATUS: "/inquiries/answers/status"
};